import {
  Card as MCard,
  CardContent as MCardContent,
  CardHeader as MCardHeader,
} from '@mui/material';

export const Card = MCard;
export const CardHeader = MCardHeader;
export const CardContent = MCardContent;
